import React, { useEffect , useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';

import { toast } from 'react-toastify';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Button, FormGroup, Label, Input, Container, Row, Col, Card, CardBody } from 'reactstrap';
import { userLogin } from '../../store/page/auth/authThunk';
import loginLeft from '../../assets/images/project-img/new-left-img-2.png';
import fiftyrites from '../../assets/images/project-img/50rites.svg';
import setting from '../../assets/images/project-img/setting.svg';
import globe from '../../assets/images/project-img/globe.svg';
import bar from '../../assets/images/project-img/bar.svg';
import { ReactComponent as LoginLogo } from '../../assets/images/project-img/RITES_green_logo.svg 1.svg';
import { resetDashboard } from '../../store/page/dashboard/dashboardSlice';

// import ForgotPassword from './ForgotPassword';

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userDetails = localStorage.getItem('user');

    // If token and loginData exist, redirect to dashboard
    if (token && userDetails) {
      navigate('/dashboards');
    }
  }, [navigate]);

  //  Initial Values
  const initialValues = {
    email: '',
    password: '',
  };
const [showPassword, setShowPassword] = useState(false);
  //  Validation Schema
  const validationSchema = Yup.object({
    email: Yup.string().email('Invalid email format').required('Email is required'),
    password: Yup.string()
      .min(6, 'Password must be at least 6 characters')
      .required('Password is required'),
  });

  //  Submit Handler
  const handleSubmit = async (values, { setSubmitting }) => {
    // const loginData = new FormData();
    // loginData.append("email", values.email); // backend expects username
    // loginData.append("password", values.password);
    const payLoad = {
      email: values.email,
      password: values.password,
    };

    try {
      const result = await dispatch(userLogin(payLoad)).unwrap();
      console.log(51, result);
      // toast.success("Login successfully!");
      toast.success(result.message);
      console.log('result===============', result);

      localStorage.setItem('token', result.token);
      localStorage.setItem('username', JSON.stringify(result?.user?.name));
      localStorage.setItem('loginData', JSON.stringify(result));
      localStorage.setItem('permissions', JSON.stringify(result?.response?.data[0].permissions));
      dispatch(resetDashboard());
      // navigate("/dashboards");
      if (result.response.success) {
        navigate('/dashboards');
      }
    } catch (err) {
      toast.error('Invalid email or password');
      console.error(' Login failed:', err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-grid">
        <div className="login-page-left-side position-relative">
          <img src={loginLeft} alt="" />
          <div className='fifty-rites'>
            <img src={fiftyrites} alt='' />
          </div>
          {/* <LoginLeft/> */}
          <div className="position-absolute left-letter">
            <div className="header-sec">
              <h3>PRATYAKSH</h3>
              <p>Ensuring Excellence in Every Coach</p>
            </div>
            {/* <p>Exporting ‘Make in India’ 3000 HP Cape Gauge AC-AC locomotives to Mozambiques.</p> */}
            {/* <p>Ensuring Excellence in Every Coach</p> */}
            <div className="mt-5">
              <p>A Digital Quality Management System for Inspection of Coaches. </p>
            </div>
            <div className="d-flex gap-3">
              <div className='left-card'>
                <img src={setting} alt="" />
                <div>
                  <p className='heading'>Quality Assurance</p>
                  <p className='sub-heading'>Rigorous inspection for unmatched quality.</p>
                </div>
              </div>
              <div className='left-card'>
                <img src={bar} alt="" />
                <div>
                  <p className='heading'>Precision Inspection</p>
                  <p className='sub-heading'>Every detail. Every standard. Every time.</p>
                </div>
              </div>
              <div className='left-card'>
                <img src={globe} alt="" />
                <div>
                  <p className='heading'>Global Standards</p>
                  <p className='sub-heading'>Built in Bharat. Trusted worldwide.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Container
          className="d-flex justify-content-center align-items-center login-right-side"
          style={{ minHeight: '100vh' }}
        >
          <Row className="w-100 login-form">
            <Col md={6} lg={7} className="mx-auto">
              <div className="text-center position-relative mb-3">
                <div className="d-flex justify-content-center">
                  {/* <img src={loginLogo} alt="logo" /> */}
                  <LoginLogo />
                </div>
                <p className="position-absolute" style={{ width: '100%', bottom: '-25px' }}>
                  (A Government of India Enterprise)
                </p>
              </div>
              <Card>
                <CardBody>
                  <div className="text-center card-head">
                    <h1>Welcome Back !</h1>
                    <p>
                      Sign in with your MCF credentials to access Quality Check Sheets for your
                      assigned shift.
                    </p>
                  </div>
                  <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                  >
                    {({ isSubmitting, touched, errors }) => (
                      <Form>
                        <FormGroup>
                          <Label className="label">Email</Label>{' '}
                          <span className="text-danger">*</span>
                          <Field
                            as={Input}
                            type="email"
                            name="email"
                            placeholder="Enter your email"
                            invalid={touched.email && errors.email}
                          />
                          <ErrorMessage name="email" component="div" className="text-danger" />
                        </FormGroup>

                        <FormGroup className="position-relative">
                          <Label className="label">Password</Label>{' '}
                          <span className="text-danger">*</span>
                          <div className="position-relative">
                            <Field
                              as={Input}
                              type={showPassword ? "text" : "password"}
                              name="password"
                              placeholder="Enter your password"
                              invalid={touched.password && errors.password}
                            />
                            <span
                              className="position-absolute"
                              style={{
                                right: '12px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                cursor: 'pointer',
                                color: '#6c757d',
                                zIndex: 10
                              }}
                              onClick={() => setShowPassword(!showPassword)}
                            >
                              <i
                                className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'} text-info`}
                                style={{ fontSize: '18px' }}
                              />
                            </span>
                          </div>
                          <ErrorMessage name="password" component="div" className="text-danger" />
                        </FormGroup>
                        <div className="d-flex justify-content-between mb-4">
                          <div className="d-flex align-item-center gap-1">
                            <input type="checkbox" name="remember" />
                            <Label className="mb-0">Keep me logged in on this device</Label>
                          </div>
                          <div className="forgot-password">
                            <Link to="/auth/ForgotPassword">Forgot Password?</Link>
                          </div>
                        </div>

                        <Button
                          color="primary"
                          block
                          type="submit"
                          className="login-button"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? 'Logging in...' : 'Login'}
                        </Button>
                      </Form>
                    )}
                  </Formik>

                  <div className="text-center terms-and-policy">
                    <span className="first">By creating an account, you agree to the</span>
                    <br />
                    <span className="second">Terms of use and Privacy Policy.</span>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default Login;
